let production = "https://api.payro.io";
let staging = "https://staging.payro.io";
let local = "http://localhost:3000";


export const API = production;
